// Import SCSS
import './common/frontend.scss';
import './order-details/frontend.scss';
import './customer-details/frontend.scss';
import './downloads/frontend.scss';
import './inline-container/frontend.scss';
